/**
*****************************************
*										*
* NAGARRO  - CSX - CONFIDENTIAL         *
*										*
*****************************************
*/
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { ConfigService } from '../../../core/services/config.service';
import { TrainData } from '../../../core/model/train-data.model';

/**
 * @export
 * @class LmsTrainPtcComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-train-ptc',
  templateUrl: './lms-train-ptc.component.html',
  styleUrls: ['./lms-train-ptc.component.scss']
})
export class LmsTrainPtcComponent implements OnInit, OnDestroy {

  @Input() trainData: TrainData;
  trainLabel: any;
  ptcTrainIndicator: string;
  requiredPtcIndicator = 'Required';
  noPtcIndicator = 'No';

  /**
   * Creates an instance of LmsTrainPtcComponent.
   * @param {ConfigService} configService
   * @memberOf LmsTrainPtcComponent
   */
  constructor(private configService: ConfigService) {
    this.trainLabel = this.configService.getConfigData().trainLabel;
  }

  /**
   * @memberOf LmsTrainPtcComponent
   */
  ngOnInit() {
    if (this.trainData && this.trainData.ptcTrainIndicator) {
      if (this.trainData.ptcTrainIndicator.trim().toUpperCase() === 'Y' ||
        this.trainData.ptcTrainIndicator.trim().toUpperCase() === 'P') {
        this.ptcTrainIndicator = this.requiredPtcIndicator;
      } else if (this.trainData.ptcTrainIndicator.trim().toUpperCase() === 'N') {
        this.ptcTrainIndicator = this.noPtcIndicator;
      } else {
        this.ptcTrainIndicator = '-';
      }
    } else {
      this.ptcTrainIndicator = '-';
    }
  }

  ngOnDestroy() {
  }

}
